import React from 'react';
import { useParams } from 'react-router-dom';
import { useStore } from 'stores/Store';
import ExerciseFeedbackPanel from 'containers/pages/person/programs/ExerciseFeedbackPanel';

const PersonProgramFeedbackTab = () => {
  const { personId } = useParams();
  const program = useStore(state => state.program);

  return <ExerciseFeedbackPanel program={program} personId={personId} />;
};

export default PersonProgramFeedbackTab;
